import { render, staticRenderFns } from "./MainBatteriesCard.vue?vue&type=template&id=4a174a5a&scoped=true"
import script from "./MainBatteriesCard.vue?vue&type=script&lang=js"
export * from "./MainBatteriesCard.vue?vue&type=script&lang=js"
import style0 from "./MainBatteriesCard.vue?vue&type=style&index=0&id=4a174a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a174a5a",
  null
  
)

export default component.exports